const map = {
	"./alert-circle-grey.svg": 38921,
	"./alert-circle-red.svg": 42021,
	"./alert-green-tick.svg": 63882,
	"./alert-red-white-i.svg": 20494,
	"./attach-file.svg": 64474,
	"./back-arrow.svg": 49290,
	"./bullet.svg": 41424,
	"./calendar-grey.svg": 16078,
	"./cancel-red.svg": 76396,
	"./cancel-white.svg": 69618,
	"./carat-down.svg": 82982,
	"./carat-right.svg": 46992,
	"./carat-up.svg": 86781,
	"./ccp-purple-tick.svg": 87857,
	"./check-circle.svg": 773,
	"./chevron-down-black.svg": 58364,
	"./chevron-down-blue-1.svg": 16585,
	"./chevron-down-blue.svg": 28735,
	"./chevron-down-grey-r3.svg": 25170,
	"./chevron-down-grey.svg": 37338,
	"./chevron-down-primary.svg": 74075,
	"./chevron-down-red.svg": 32436,
	"./chevron-down-white.svg": 37242,
	"./chevron-fill-right-grey.svg": 44260,
	"./chevron-right-grey.svg": 31128,
	"./chevron-right-purple.svg": 3087,
	"./chevron-right-white.svg": 16008,
	"./chevron-standard-down-grey.svg": 54450,
	"./chevron-up-blue.svg": 82578,
	"./chevron-up-red.svg": 40543,
	"./chevron-up-white.svg": 47321,
	"./circle-cancel-black.svg": 41169,
	"./circle-cancel-red.svg": 22821,
	"./circle-down-arrow-purple.svg": 46320,
	"./close-black.svg": 80766,
	"./close-grey.svg": 43988,
	"./close-red.svg": 78454,
	"./close-white.svg": 59620,
	"./close.svg": 55876,
	"./compare-badge.svg": 68727,
	"./confirmation-tick-grey.svg": 69065,
	"./confirmation-tick-white.svg": 18471,
	"./confirmation-tick.svg": 23559,
	"./contact-item-call.svg": 10553,
	"./contact-item-ellipse.svg": 31669,
	"./contact-item-email.svg": 94467,
	"./contact-item-faq.svg": 94755,
	"./delete.svg": 86649,
	"./document-primary.svg": 73158,
	"./document.svg": 52867,
	"./documentIcon-dot.svg": 65538,
	"./dollar-circle-icon.svg": 12683,
	"./download-green.svg": 92218,
	"./download-purple-new.svg": 20666,
	"./download-purple.svg": 95463,
	"./download-white.svg": 24096,
	"./download.svg": 33424,
	"./email-Icon.svg": 91786,
	"./error-tick.svg": 69544,
	"./error.svg": 21218,
	"./evergreen-download-brochure.svg": 53715,
	"./evergreen-download.svg": 814,
	"./evergreen-drawer-arrow.svg": 42877,
	"./evergreen-green-tick.svg": 66479,
	"./evergreen-help.svg": 13375,
	"./evergreen-info-black-filled.svg": 78921,
	"./evergreen-plan-green.svg": 18597,
	"./evergreen-plan.svg": 70723,
	"./evergreen-tick.svg": 39381,
	"./faq-Icon.svg": 49898,
	"./female.svg": 15744,
	"./gray-copy-icon.svg": 45773,
	"./green-round-tick.svg": 81572,
	"./health-cio-chief-information-officer-badge.svg": 22592,
	"./i.svg": 40713,
	"./info-animation-grey.svg": 48887,
	"./info-black-lg.svg": 11172,
	"./info-black.svg": 47590,
	"./info-error.svg": 95721,
	"./info-gray-solid.svg": 71206,
	"./info-primary.svg": 77153,
	"./info-yellow.svg": 82949,
	"./info.svg": 99868,
	"./information-red.svg": 52328,
	"./invalid-message.svg": 62131,
	"./light-bulb.svg": 75824,
	"./male.svg": 1559,
	"./me-and-someone-else-badge.svg": 5615,
	"./message-box.svg": 93353,
	"./notification.svg": 2893,
	"./pencil-blue.svg": 12276,
	"./pencil.svg": 45871,
	"./pennies-for-good-badge.svg": 53396,
	"./phone-Icon.svg": 9694,
	"./plus-shield-circle-active.svg": 59422,
	"./plus-shield-circle-hover.svg": 6310,
	"./plus-shield-circle-inactive.svg": 39123,
	"./product-1.svg": 91695,
	"./product-2.svg": 12668,
	"./product-3.svg": 83293,
	"./promo-discount-applied-icon.svg": 45711,
	"./promo-discount-icon.svg": 72407,
	"./receive-money-quickly-badge.svg": 43321,
	"./round-tick-success.svg": 72572,
	"./shield-circle-active.svg": 67091,
	"./shield-circle-hover.svg": 58533,
	"./shield-circle-inactive.svg": 65434,
	"./sign_line.svg": 13768,
	"./singpass-permission-button.svg": 73363,
	"./specialist-care-and-treatment-badge.svg": 83618,
	"./success-tick.svg": 95133,
	"./swap-red-icon.svg": 78519,
	"./swap.svg": 17953,
	"./tick-green.svg": 20641,
	"./tick-purple.svg": 44054,
	"./tick-white.svg": 73495,
	"./tool-tip-bottom.svg": 12822,
	"./tool-tip-tectangle.svg": 38328,
	"./tool-tip-top.svg": 3180,
	"./tools-and-calculator-badge.svg": 19728,
	"./tooltip-i-grey.svg": 39693,
	"./tooltip-i-white.svg": 87627,
	"./tootltip-i-green.svg": 27325,
	"./triangle-error.svg": 1025,
	"./underwriting-applied-icon.svg": 58872,
	"./underwriting-campaign-icon.svg": 75341,
	"./valid-message.svg": 45788,
	"./visit-Icon.svg": 40621,
	"./yellow-info.svg": 25849
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11643;